<template>
    <div class="main">
        
       <!-- 轮播图 -->
       <div class="carousel">
        <el-carousel :interval="4000" type="card" autoplay>
            <el-carousel-item v-for="item in carouselList" :key="item.id" class="carouselImage" >
                <div>
                    <img :src="item.firstFile.FileUrl" style="width: 100%;object-fit: cover;" alt="">
                </div>
            </el-carousel-item>
        </el-carousel>  
       </div>
       
       <div class="userNum">
           
            <div>
                <el-carousel height="40px" direction="vertical" autoplay :interval="4000">
                    <el-carousel-item >
                       <span @click="handleListcompany"> 入驻企业数：{{ statInfo.company_amount }}</span>
                    </el-carousel-item>
                    <el-carousel-item>
                        总浏览次数：{{ statInfo.visit_amount }}
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div>
                <el-carousel height="40px" direction="vertical" autoplay :interval="4000">
                    <el-carousel-item v-for="item in newsList" :key="item.id" @click="HandleNews(item)">
                       <span  @click="HandleNews(item)"> {{ item.title }}</span>
                    </el-carousel-item>
                </el-carousel>
            </div>
       </div>
      
       <Container1></Container1>
       <Container2></Container2>
       <Container3></Container3>
       <Container4></Container4>
       <!-- 安全培训 -->
       <training></training>
       <div class="advertisement" v-if="homepcmidbanner != ''">
      <div v-for="item in homepcmidbanner" :key="item.id">
        <img :src="item.firstFile.FileUrl" style="width: 100%;object-fit: cover;" alt="">
      </div>
      <!-- <div></div> -->
    </div>  

       <!-- 赋能 -->
       <enable style="margin-top: 20px"></enable>

        
       
    </div>
</template>

<script>
// import {mapActions,mapState} from "vuex"
import Expert from '../expert/index.vue'
import Container1 from './container1.vue'
import Container2 from './container2.vue'
import Container3 from './container3.vue'
import Container4 from './container4.vue'
// import enable from './enable.vue'
import enable from '../funeng/enable.vue'
import training from './training.vue'
export default{
    data(){
        return{
            navPosition: 1,
            carouselList: [],
            newsList: [],
            statInfo: [],
            homepcmidbanner: []
        }
    },
    components: {
        Expert,
        Container1,
        Container2,
        Container3,
        Container4,
        enable,
        training,
    },
    methods: {
        HandleNews(item){
            const { href } = this.$router.resolve({
                path: '/detailPages',
                query: {
                    key: item.id,
                    currentName: '新闻资讯'
                }
            });
            window.open(href, '_blank');
        },
        handleListcompany(){
            this.$router.push({
                path: '/listcompany'
            })
        },
        getImage(val){
             let data = {
                cate_value: val
            }
            this.$store.dispatch('login/listads',data)
                .then(res => {
                    if(val == 'homebanner'){
                        this.carouselList = res.data.items
                    }else if(val == 'homepcmidbanner'){
                        this.homepcmidbanner = res.data.items
                    }
                    
                })
        }
    },
    mounted(){
        this.getImage('homebanner')
        this.getImage('homepcmidbanner')
       

        let newsData = {
            pageNum : 1,
            pageSize: 5,
            channel: 'news'
        }
        this.$store.dispatch('home/listarticle',newsData)
            .then(res => {
                if(res.ok){
                    this.newsList = res.data.items
                }
            })
        
        let sInfo = {}
        this.$store.dispatch('home/statInfo',sInfo)
            .then(res => {
                if(res.ok){
                    this.statInfo = res.data
                }
            })
    }
}
</script>
<style>
@media screen and (min-width: 541px) {
    .carousel .el-carousel__container{
        height: 400px;
    }
}
@media screen and (max-width: 541px) {
    .carousel .el-carousel__container{
        height: 200px;
    }
}
</style>
<style scoped>
.main{
    width: 1200px;
    margin: 20px auto;
    padding: 10px 10px;
    /* background: #fff; */

}
.carousel{
    width: 100%;height: 400px;
}

.carousel .carouselImage{
    width: 880px;
    margin-left: -140px;
}


.userNum{
    /* background: #fff; */
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    margin-top: 40px;
    padding-left: 25px;
    height: 60px;
    color: rgb(153, 0, 0);
    /* padding: 10px 0 10px 10; */
    background: #fff;
}
.userNum div{
    width: 95%;
    /* border: 1px solid; */
    /* font-size: 20px; */
    cursor: pointer;
     overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.advertisement{
    display: flex;
    justify-content: space-between;
    height: 100px;
    margin-top: 20px;
    background: #fff;
    padding: 10px 10px;
}
.advertisement div{
    width: 48%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    
}
.advertisement div:nth-child(1){  
    background-image:url('../../assets/955291b8-dc58-4240-8ff8-1f8b48e82f65.jpg');
}
.advertisement div:nth-child(2){  
    background-image:url('../../assets/8f0527c6-71e9-4003-86b3-5d4a078627ae.png');
}

.el-carousel__item {
    font-size: 18px;
    line-height: 40px;
 }
 @media screen and (max-width: 540px) {
    .main{
        width: 95%;
        margin: 20px auto;
        padding: 0 0;

    }
    .carousel{
        height: 230px;
    }

    .carousel .carouselImage{
        width: 90%;
        margin-left: -20%;
    }


        
    .userNum{
        margin: 0px auto;
        height: 40px;
        padding-left: 5px;
    }
    .el-carousel__item{
        font-size: 14px;
    }

 }
</style>